module.exports = __webpack_public_path__ + "static/media/getreskilled.82c8f53a.jpg";